import React, { Fragment } from 'react'
import useApi from 'hooks/useApi'
import { MenuButton, Icon } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'

const AutomationMenuFragments = ({ readOnly, taskId }) => {
  const [settings,loading,, reload] = useApi(`/notification/getNotificationSettingsForTaskId?taskId=${taskId}`)

  const list = [
    {
      key: 'TaskPreApproveSupplierFileValue',
      message: 'Automatically send files to client',
      handler: () => fetch(`/ordertask/testTaskForSupplierAutoDelivery.html?taskId=${taskId}`)
      .then((response) => response.text())
      .then((response) => {
        if (response !== 'OK') {
          return Promise.reject(`
            Sourcing does not allow auto-delivery with this supplier. Consult sourcing if you think auto-delivery is necessary for this supplier.
          `)
        }

        return fetch(`/notification/setTaskPreApproveSupplierFile`, {
          method: 'POST',
          body: new URLSearchParams({ taskId, value: +!settings.TaskPreApproveSupplierFileValue })
        })
      })
      .then((response) => response.text())
      .then(reload)
      .catch((error) => toastr.error(error))
    },
    {
      key: 'TaskBypassCustomerNotificationValue',
      message: 'Make files visible without notifying client',
      handler: () => fetch(`/notification/setTaskBypassCustomerNotification.html`,{
        method: 'POST',
        body: new URLSearchParams({ taskId, value: +!!settings.TaskBypassCustomerNotificationValue })
      })
      .then((response) => response.text())
      .then(reload)
      .catch((error) => toastr.error(error))
    },
    {
      key: 'TaskPreApproveForCustomerFileValue',
      message: 'Approve files for client',
      handler: () => fetch(`/notification/setTaskPreApproveForCustomerFile.html`,{
        method: 'POST',
        body: new URLSearchParams({ taskId, value: +!settings.TaskPreApproveForCustomerFileValue })
      })
      .then((response) => response.text())
      .then(reload)
      .catch((error) => toastr.error(error))
    },
  ]

  return (
    <Fragment>
      <Menu.Item disabled>
        {(props) => (
          <MenuButton {...props} disabled className="cursor-help">
            Automation {loading && 'loading..'}
          </MenuButton>
        )}
      </Menu.Item>

      { settings ? list.map(({ key, handler, message }) => (
          <Menu.Item key={key} disabled={readOnly}>
            {(props) => (
              <div
                disabled={readOnly}
                {...props}
                className="block px-4 py-2 text-sm text-gray-700 w-full text-left hover:bg-gray-100 cursor-pointer"
              >
                <div
                  className="flex justify-between items-center space-x-4"
                  onClick={(e) => {
                    e.stopPropagation();
                    handler();
                  }}
                >
                  <span>{ message }</span>
                  <Icon icon={settings[key] ? 'check-square' : 'square'} />
                </div>
              </div>
            )}
          </Menu.Item>
      )) : (
        <Menu.Item disabled>
          {(props) => (
            <MenuButton {...props} disabled>
              Loading..
            </MenuButton>
          )}
        </Menu.Item>
      ) }
    </Fragment>
  )
}

export default AutomationMenuFragments
